import type { Channel } from "../mocks/articles";

export function chipSoft(color: Channel["color"]): string {
  switch (color) {
    case "primary":
      return "bg-primary-100 text-primary-800 border-primary-200";
    case "accent":
      return "bg-accent-100 text-accent-900 border-accent-200";
    default:
      return "bg-secondary-100 text-secondary-900 border-secondary-200";
  }
}

export function chipSolid(color: Channel["color"]): string {
  switch (color) {
    case "primary":
      return "bg-primary-500 text-background-50";
    case "accent":
      return "bg-accent-500 text-background-50";
    default:
      return "bg-secondary-500 text-background-50";
  }
}